/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindMaterialTypesByOperationChainQueryResponse,
  FindMaterialTypesByOperationChainQueryParams,
} from "../types/FindMaterialTypesByOperationChain.ts"

export const findMaterialTypesByOperationChainQueryKey = (
  params: FindMaterialTypesByOperationChainQueryParams
) =>
  [
    { url: "/v1/material-type/find-material-types-by-operation-chain" },
    ...(params ? [params] : []),
  ] as const

export type FindMaterialTypesByOperationChainQueryKey = ReturnType<
  typeof findMaterialTypesByOperationChainQueryKey
>

/**
 * @summary Find material types by operation chain
 * {@link /v1/material-type/find-material-types-by-operation-chain}
 */
export async function findMaterialTypesByOperationChain(
  params: FindMaterialTypesByOperationChainQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindMaterialTypesByOperationChainQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/material-type/find-material-types-by-operation-chain`,
    params,
    ...requestConfig,
  })
  return res
}

export function findMaterialTypesByOperationChainQueryOptions(
  params: FindMaterialTypesByOperationChainQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findMaterialTypesByOperationChainQueryKey(params)
  return queryOptions<
    ResponseConfig<FindMaterialTypesByOperationChainQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindMaterialTypesByOperationChainQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findMaterialTypesByOperationChain(params, config)
    },
  })
}

/**
 * @summary Find material types by operation chain
 * {@link /v1/material-type/find-material-types-by-operation-chain}
 */
export function useFindMaterialTypesByOperationChain<
  TData = ResponseConfig<FindMaterialTypesByOperationChainQueryResponse>,
  TQueryData = ResponseConfig<FindMaterialTypesByOperationChainQueryResponse>,
  TQueryKey extends QueryKey = FindMaterialTypesByOperationChainQueryKey,
>(
  params: FindMaterialTypesByOperationChainQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindMaterialTypesByOperationChainQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findMaterialTypesByOperationChainQueryKey(params)

  const query = useQuery(
    {
      ...findMaterialTypesByOperationChainQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
